// extracted by mini-css-extract-plugin
module.exports = {"label":"_7a3fb80146--label--U5tEg","green":"_7a3fb80146--green--vQyX0","yellow":"_7a3fb80146--yellow--aGJwf"};